export default __webpack_public_path__ + "static/media/coinca l plano3.444651af.jpg";